import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=0e3b883d&scoped=true&functional=true&"
var script = {}
import style0 from "./Feature.vue?vue&type=style&index=0&id=0e3b883d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0e3b883d",
  null
  
)

export default component.exports